import React, { useState } from 'react';
import './Card.css';

export default function Profile({ token, user, onUpdate }) {
  const [apiKey, setApiKey] = useState('');
  const [status, setStatus] = useState('');

  const saveKey = async () => {
    const res = await fetch('/api/user/key', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ apiKey })
    });
    const data = await res.json();
    if (res.ok) {
      setStatus('API key saved!');
      setApiKey('');
      onUpdate();
    } else {
      setStatus(data.error || 'Failed');
    }
  };

  const closeModal = () => {
    document.getElementById('profile-modal').style.display = 'none';
  };

  return (
    <div id="profile-modal" className="modal">
      <div className="modal-content">
        <span className="close" onClick={closeModal}>&times;</span>
        <h2>Your Profile</h2>
        <p>Email: {user?.email}</p>
        <label>API Key (sk-...)</label>
        <input type="password" value={apiKey} onChange={e => setApiKey(e.target.value)} placeholder="Enter your API key" />
        <button onClick={saveKey}>Save Key</button>
        <div id="profile-status">{status}</div>
        <p><small>Your key is encrypted and stored securely.</small></p>
      </div>
    </div>
  );
}
